import {
  NotificationActionTypes,
  NOTIFICATION_SUCCESS,
  NOTIFICATION_ERROR,
  NOTIFICATION_WARNING,
  NOTIFICATION_INFO,
} from './types';

export function notifySuccess(successMsg: string): NotificationActionTypes {
  return {
    type: NOTIFICATION_SUCCESS,
    payload: successMsg,
  };
}

export function notifyError(errorMsg: string): NotificationActionTypes {
  return {
    type: NOTIFICATION_ERROR,
    payload: errorMsg,
  };
}

export function notifyWarning(warningMsg: string): NotificationActionTypes {
  return {
    type: NOTIFICATION_WARNING,
    payload: warningMsg,
  };
}

export function notifyInfo(infoMsg: string): NotificationActionTypes {
  return {
    type: NOTIFICATION_INFO,
    payload: infoMsg,
  };
}

export function clearNotification(notificationChannel: string): NotificationActionTypes {
  switch (notificationChannel) {
    case 'success':
      return {
        type: NOTIFICATION_SUCCESS,
        payload: undefined,
      };
    case 'error':
      return {
        type: NOTIFICATION_ERROR,
        payload: undefined,
      };
    case 'warning':
      return {
        type: NOTIFICATION_WARNING,
        payload: undefined,
      };
    case 'info':
      return {
        type: NOTIFICATION_INFO,
        payload: undefined,
      };
    default:
      throw Error(`Unknown notification channel ${notificationChannel}`);
  }
}
